import servicesUtils from 'utils/Services';
const shouldServiceRun = servicesUtils.shouldServiceRun;
import store from 'Store';
import BasketActions from 'actions/BasketActions';

export default (function () {
    // Stop service from loading if not necessary
    if (!shouldServiceRun.refreshBasket()) {
        return;
    }

    Sephora.Util.InflatorComps.services.RefreshBasketService = () => {
        store.dispatch(BasketActions.refreshBasket(true));
    };
}());
